import { render, staticRenderFns } from "./ClassAgentIcon.vue?vue&type=template&id=73707ccd&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73707ccd')) {
      api.createRecord('73707ccd', component.options)
    } else {
      api.reload('73707ccd', component.options)
    }
    module.hot.accept("./ClassAgentIcon.vue?vue&type=template&id=73707ccd&", function () {
      api.rerender('73707ccd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/ClassAgentIcon.vue"
export default component.exports